import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import PanelLayout from './panel_layout'
import List from '../list'
import { expandGabTrendsFeeds } from '../../actions/news'

class NewsFeedsPanel extends React.PureComponent {

  componentDidMount() {
    const { isFetched, dispatch } = this.props

    if (!isFetched) dispatch(expandGabTrendsFeeds())
  }

  render() {
    const { rssFeeds, isLoading, isFetched, noPanel } = this.props
    
    if (!rssFeeds || isLoading || !isFetched) return null

    const pathname = window.location.pathname
    const items = rssFeeds.sortBy(Math.random).toJS().map((item) => {
      return {
        shouldHighlight: 1,
        isActive: pathname.indexOf(item.id) > -1,
        image: item.image,
        title: item.title,
        to: `/news/view/${item.id}`,
      }
    }).sort((a, b) => b.isActive - a.isActive)

    return (
      <PanelLayout
        noPadding
        noPanel={noPanel}
        title='News feeds'
      >
        <div className={[_s.d, _s.boxShadowNone, _s.boxShadowNoneBg, _s.w100PC].join(' ')}>
          <List items={items} />
        </div>
      </PanelLayout>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    rssFeeds: state.getIn(['news', 'rss_feeds', 'items']),
    isLoading: state.getIn(['news', 'rss_feeds', 'isLoading']),
    isFetched: state.getIn(['news', 'rss_feeds', 'isFetched']),
  }
}

NewsFeedsPanel.propTypes = {
  //
}

export default connect(mapStateToProps)(NewsFeedsPanel)